import type {
    ModelRawClassOptionSummary,
    ModelRecognitionTypeSummary,
} from '../types/modelManagement'

export const buildModelRecognitionTypes = (
    options: ModelRawClassOptionSummary[],
): ModelRecognitionTypeSummary[] => {
    return options.map((option) => ({
        model_keys: option.model_keys,
        raw_class: option.raw_class,
        raw_class_norm: option.raw_class_norm,
        display_name_zh: option.display_name_zh,
        color: option.color,
        source_versions: option.source_versions,
    }))
}
